export default {
  lang: {
    export: 'នាំចេញ',
    successfully: 'នាំចេញ ភារកិច្ច បាន បង្កើត ដោយ ជោគជ័យ',
    pleaseJumpTo: 'សូម លុប',
    uploadAndDownloadCenter: 'ផ្ទុក ឡើង និង ទាញយក មជ្ឈមណ្ឌល',
    check: 'ទិដ្ឋភាព',
    exportAll: 'អះអាង ដើម្បី នាំចេញ មាតិកា ទាំងអស់ ឬ ?',
    total: 'សរុប',
    confirm: 'ទិន្នន័យ អះអាង នាំចេញ ?',
    error:
      'ចំនួន ទិន្នន័យ ដែល អាច នាំចេញ គឺ ០ សូម ផ្លាស់ប្ដូរ ទិន្នន័យ តម្រង ហើយ ព្យាយាម ម្ដង ទៀតName',
  },
};
